export function eventSlider() {
    const sliders = document.querySelectorAll('.site-slider');
    const scrollbars = document.querySelectorAll('.site-events__scrollbar');
    const thumbs = document.querySelectorAll('.site-events__scrollbar-thumb');

    sliders.forEach((slider, index) => {
        const scrollbar = scrollbars[index];
        const thumb = thumbs[index];


        function updateThumbPosition() {
            const scrollPercentage = slider.scrollLeft / (slider.scrollWidth - slider.clientWidth);
            const thumbPosition = scrollPercentage * (scrollbar.clientWidth - thumb.clientWidth);
            thumb.style.transform = `translateX(${thumbPosition}px)`;
        }


        function moveSlider(e) {
            const rect = scrollbar.getBoundingClientRect();
            const clickPosition = e.clientX - rect.left;
            const scrollPosition = (clickPosition / scrollbar.clientWidth) * (slider.scrollWidth - slider.clientWidth);
            slider.scrollLeft = scrollPosition;
        }

        let isDragging = false;
        let startX, thumbPositionStart;

        thumb.addEventListener('mousedown', (e) => {
            isDragging = true;
            startX = e.clientX;
            thumbPositionStart = thumb.offsetLeft;
            document.body.style.userSelect = 'none';
        });

        document.addEventListener('mouseup', () => {
            isDragging = false;
            document.body.style.userSelect = '';
        });

        document.addEventListener('mousemove', (e) => {
            if (!isDragging) return;
            const deltaX = e.clientX - startX;
            const newLeft = Math.min(
                scrollbar.clientWidth - thumb.clientWidth,
                Math.max(0, thumbPositionStart + deltaX)
            );
            const scrollPercentage = newLeft / (scrollbar.clientWidth - thumb.clientWidth);
            slider.scrollLeft = scrollPercentage * (slider.scrollWidth - slider.clientWidth);
        });

        scrollbar.addEventListener('click', moveSlider);
        slider.addEventListener('scroll', () => {
            updateThumbPosition();
            updateArrows();
        });
        updateThumbPosition();

        const container = slider.parentElement;
        const leftArrow = container.querySelector('.slider-arrow--left');
        const rightArrow = container.querySelector('.slider-arrow--right');

        const scrollAmount = slider.clientWidth * 0.6;

        if (leftArrow) {
            leftArrow.addEventListener('click', () => {
                slider.scrollBy({
                    left: -scrollAmount,
                    behavior: 'smooth'
                });
            });
        }

        if (rightArrow) {
            rightArrow.addEventListener('click', () => {
                slider.scrollBy({
                    left: scrollAmount,
                    behavior: 'smooth'
                });
            });
        }

        function updateArrows() {
            if (leftArrow) {
                if (slider.scrollLeft === 0) {
                    leftArrow.disabled = true;
                    leftArrow.classList.add('disabled');
                } else {
                    leftArrow.disabled = false;
                    leftArrow.classList.remove('disabled');
                }
            }
            if (rightArrow) {
                if (Math.ceil(slider.scrollLeft + slider.clientWidth) >= slider.scrollWidth) {
                    rightArrow.disabled = true;
                    rightArrow.classList.add('disabled');
                } else {
                    rightArrow.disabled = false;
                    rightArrow.classList.remove('disabled');
                }
            }
        }

        updateArrows();
    });
}
